<template>
  <div>
    <slot name="group:title"></slot>
    <div class="grid col-span-2 gap-4 sm:grid-cols-2">
      <component
        v-for="c in components"
        :key="c.key"
        :is="c.name"
        :controls="controls"
        :value="c.value"
        :checked="c.value"
        :http-errors="c.errors"
        @input:field="onInput($event, c.key)"
      ></component>
    </div>
  </div>
</template>

<script>
import FieldFirstName from "@/components/Field/Patient/FirstName";
import FieldLastName from "@/components/Field/Patient/LastName";
import FieldEmail from "@/components/Field/Patient/Email";
import FieldGender from "@/components/Field/Patient/Gender";
import FieldBirthDate from "@/components/Field/Patient/BirthDate";
import FieldMobilePhone from "@/components/Field/Patient/MobilePhone";
import FieldAddress from "@/components/Field/Patient/Address";
import FieldState from "@/components/Field/Patient/State";
import FieldZip from "@/components/Field/Patient/Zip";
import FieldCity from "@/components/Field/Patient/City";
import FieldAppointmentNotes from "@/components/Field/Patient/AppointmentNotes";
import FieldConfirm from "@/components/Field/Patient/Confirm";
const FIELDS = [
  "first_name",
  "last_name",
  "email",
  "gender",
  "birth_date",
  "mobile_phone",
  "address",
  "state",
  "zip",
  "city",
  "appointment_notes",
  "confirm",
];

export default {
  components: {
    FieldFirstName,
    FieldLastName,
    FieldEmail,
    FieldGender,
    FieldBirthDate,
    FieldMobilePhone,
    FieldAddress,
    FieldState,
    FieldZip,
    FieldCity,
    FieldAppointmentNotes,
    FieldConfirm,
  },
  props: ["controls", "errors"],
  computed: {
    isAscend() {
      return this.controls?.locations?.software === "dentrixascend";
    },
    isReverse() {
      return this.$store.getters.flowType === "reverse";
    },
    isSingle() {
      return this.$store.getters.isSingleLocation;
    },
    isVerificationSmsEmail() {
      // email, email_sms, auto_confirm
      return this.$store?.state?.settings?.verification === "email_sms";
    },
    fields() {
      if (this.isAscend && this.isVerificationSmsEmail) {
        return FIELDS;
      }

      if (this.isAscend && !this.isVerificationSmsEmail) {
        return FIELDS.filter((f) => !["confirm"].includes(f));
      }

      if (!this.isAscend && this.isVerificationSmsEmail) {
        return FIELDS.filter(
          (f) => !["address", "state", "zip", "city"].includes(f)
        );
      }

      return FIELDS.filter(
        (f) => !["address", "state", "zip", "city", "confirm"].includes(f)
      );
    },
    components() {
      return this.fields.map((el) => ({
        key: el,
        name: "field-" + el.replace(/_/g, "-"),
        value: this.controls[el],
        errors: this.errors?.validation?.[`input.${el}`],
      }));
    },
  },
  methods: {
    onInput(value, key) {
      this.$emit("input:group", { value, key });
    },
  },
};
</script>
